import {getDataWithPromise, Globals} from "root/globals";
import {handleAjaxError} from "root/DataFunctions/ErrorHandlingFunctions";


export const getUsersForSchoolByUserType = (school_id, user_type, onComplete) =>
{
    ///todo school_id as args, user type as filter - Using old iteration of get school users by type written by steve - Look at rewriting this

    const queryParam = '?user_type=' + user_type;

    const url = Globals.APIFolder + '/school/' + school_id + '/users2' + queryParam ; //todo - replace the use of 2

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getUserDetails = (enc_user_id, user_type, onComplete) =>
{
    const url = Globals.APIFolder + '/eyfs/_user/' + enc_user_id + '/' + user_type ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateUsernameWithChecks = (enc_user_id, formData, user_type, onComplete) =>
{
    const url = Globals.APIFolder + '/users/' + enc_user_id + '/names';

    getDataWithPromise ( url, 'PUT', {formData} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}